import { render, staticRenderFns } from "./tikus.vue?vue&type=template&id=1979282c&scoped=true"
import script from "./tikus.vue?vue&type=script&lang=js"
export * from "./tikus.vue?vue&type=script&lang=js"
import style0 from "./tikus.vue?vue&type=style&index=0&id=1979282c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979282c",
  null
  
)

export default component.exports